import { render, staticRenderFns } from "./AreaAnswer.vue?vue&type=template&id=b72e40f4&scoped=true"
import script from "./AreaAnswer.vue?vue&type=script&lang=js"
export * from "./AreaAnswer.vue?vue&type=script&lang=js"
import style0 from "./AreaAnswer.vue?vue&type=style&index=0&id=b72e40f4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72e40f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b72e40f4')) {
      api.createRecord('b72e40f4', component.options)
    } else {
      api.reload('b72e40f4', component.options)
    }
    module.hot.accept("./AreaAnswer.vue?vue&type=template&id=b72e40f4&scoped=true", function () {
      api.rerender('b72e40f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/vocational-evaluation/tabs/five/instrument/workSampleExecution/components/AreaAnswer.vue"
export default component.exports